import { useAddItemSku } from '@/custom-widget/MindMap/hooks';
import { SPI, DialogViewActionWidget, BaseActionWidget, ClickResult, Widget } from '@kunlun/dependencies';

const { itemSkuHeaderList } = useAddItemSku();
@SPI.ClassFactory(
  BaseActionWidget.Token({
    model: 'deli.retail.RetailItemSku',
    name: ['uiClient721625836554131142-17500636767000700yYgm', 'uiClient800274483111210095-17500636767000700yYgm']
  })
)
export class AddItemSkuActionWidget extends DialogViewActionWidget {
  @Widget.Reactive()
  public get disabled() {
    return itemSkuHeaderList.value.length >= 3 || (this.rootData?.[0]?.itemSkus as any)?.length === 0;
  }

  protected clickAction(...args: unknown[]): Promise<ClickResult> {
    itemSkuHeaderList.value.push({ attrName: '', showDelIcon: true });

    if (this.dataSource?.length) {
      this.dataSource.forEach((item: any) => {
        if (!item?.attrs) {
          item.attrs = [];
        }
        item.attrs.push({
          attrName: '',
          attrValue: ''
        });
      });
    }

    return false as any;
  }
}
